// frontend/src/AuthWrapper.jsx

import React from "react";
import { useAuth } from "./contexts/AuthContext";
import { SocketProvider } from "./contexts/SocketContext";
import App from "./App";

/**
 * Conditionally includes SocketProvider for authenticated users.
 * If not authenticated, we skip the SocketProvider so no
 * websockets open on login/register pages.
 */
export default function AuthWrapper() {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    // Render the main <App> without socket features
    return <App />;
  }

  // If authenticated, wrap <App> in <SocketProvider>
  return (
    <SocketProvider>
      <App />
    </SocketProvider>
  );
}
